export default "__VITE_ASSET__PgjZopfU__"